/**
 * @description 分享事件
 * @author yanchaoren
 */

/**
 * 拉起分享
 */
export default function invokeShare() {
    if (window.D == null) {
        return
    }
    const D = window.D
    const shareData = window.__DATA__.shareData
    D.setShare(shareData)
    if (D.is('inNative')) {
        D.invokeShare()
    } else {
        D.invokeShare(
            'weixin_appmsg|weixin_timeline|alipay|alipay_appmsg|alipay_timeline|qq_appmsg|qzone',
            shareData
        )
    }
}
